import { Box, Text } from '@chakra-ui/react';
import {
  Select as ChakraSelect,
  type GroupBase,
  type SingleValue,
} from 'chakra-react-select';
import { useEffect } from 'react';

import { FilterId } from '../../filters/types/filters';
import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';
import type { PrimaryFilterConfig } from '../PageConfigProvider/page-reducer';
import type { PositionedItem } from '../PageConfigProvider/types/item';
import { BaseSelectStyles } from './BaseSelectStyles';
import {
  type DimensionSourceOption,
  getAllDimensionSourceOptions,
} from './utils/dimension-source-options';

export { getAllDimensionSourceOptions } from './utils/dimension-source-options';

export const DimensionSourceSelector = ({
  item,
  primaryFilter,
}: {
  item: PositionedItem;
  primaryFilter: PrimaryFilterConfig;
}) => {
  const { dispatch } = useTabContentConfig();
  const primaryFilterId = primaryFilter.id;

  const { dimensionSource } = item?.plot ?? {};
  const metric = item?.plot?.defaultMetricOptions?.[0];

  const availableDimensionSources = getAllDimensionSourceOptions({
    chartType: item?.plot?.chartType,
    primaryFilterId,
    metric,
    dimensionSource,
  });

  const selectedDimensionSource =
    availableDimensionSources.find(
      (source) => source.value === dimensionSource
    ) ?? null;

  useEffect(() => {
    if (
      (!selectedDimensionSource?.value || !availableDimensionSources.length) &&
      !!dimensionSource &&
      metric !== undefined
    ) {
      dispatch({
        type: 'REMOVE_ITEM_DIMENSION_SOURCE',
        payload: { id: item.id },
      });
    }
  }, [
    dimensionSource,
    selectedDimensionSource?.value,
    availableDimensionSources?.length,
    metric,
    dispatch,
    item.id,
  ]);

  const onChangeDimensionSource = (
    option: SingleValue<DimensionSourceOption>
  ) => {
    if (!option) {
      dispatch({
        type: 'REMOVE_ITEM_DIMENSION_SOURCE',
        payload: { id: item.id },
      });
      return;
    }

    dispatch({
      type: 'UPDATE_ITEM_DIMENSION_SOURCE',
      payload: { id: item.id, dimensionSource: option.value },
    });
  };

  if (
    primaryFilterId === FilterId.ROLE &&
    metric !== undefined &&
    metric !== 'headcount'
  ) {
    return null;
  }
  if (availableDimensionSources.length === 0) return null;

  return (
    <Box marginBottom="1.5rem">
      <Text fontSize="sm" fontWeight={600} marginBottom="0.5rem">
        Comparison
      </Text>
      <ChakraSelect<
        DimensionSourceOption,
        false,
        GroupBase<DimensionSourceOption>
      >
        chakraStyles={BaseSelectStyles}
        options={availableDimensionSources}
        value={selectedDimensionSource}
        onChange={onChangeDimensionSource}
        isClearable
        isSearchable
      />
    </Box>
  );
};
